/**
 * @module modules/regenerateLinkCallback
 * @description Helper function to regenerate one-time download links for purchased asset packages.
 * Calls the assets Netlify function to create fresh download tokens.
 */

import { apiCall } from 'api/apiCall';

/**
 * @function regenerateLinkCallback
 * @description Make request to Netlify function to regenerate one-time download link for a given order.
 * Triggers package recreation with fresh expiry dates and download tokens.
 * @param {string} orderId - Order ID to regenerate download link for
 * @returns {Promise<Object>} Promise resolving to API response with new package info
 */
export const regenerateLinkCallback = (orderId) =>
  apiCall(`assets?orderId=${orderId}`);
